import React from 'react'
import Api from 'EurestoApi/Api'
import Fiche from '../../Component/Fiche/index'
import Utils from 'EurestoFonction/Utils'

export default class extends React.Component {
  constructor(props){
    super(props)
  }

  render() {
    const id = this.props.params.id
    let paramsSend = {'id': id, 'requete': 'produit', 'action': 'get'}
    return (<div key={Utils.getRandomNumber()}>
      <Api method={'gestion'} dataSend={paramsSend} template={get}/>
    </div>)
  }

}

class get extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: []
    }
  };

  componentDidMount () {
    let DATA = this.props.data
    this.setState({
      data: DATA
    })
  }

  render () {
    //var typeEntite = this.props.data.results.entite
    return (
      <Fiche typeaction="update" data={this.props.data.results}/>
    )
  }
}




// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Page/Modification/index.js